export default {
  computed: {
    flags() {
      return this.$store.getters.featureFlags
    },
  },
}
